import React, { useEffect, useState } from "react";
import { FaTrash, FaCaretUp, FaCaretDown } from "react-icons/fa";
import { AddOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";

const API_BASE = "https://mediapi.onlinepharmaque.in/api/v1";

const HealthComponet = () => {
  const [showModal, setShowModal] = useState(false);
  const [sliders, setSliders] = useState([]);
  const [sortDir, setSortDir] = useState("asc");
  const [sliderImg, setSliderImg] = useState(null);

  /* ================= FETCH ================= */
  const fetchSliders = async () => {
    try {
      const res = await fetch(`${API_BASE}/getthirdImg`);
      const data = await res.json();
      setSliders(data.result || []);
    } catch {
      toast.error("Failed to load sliders");
    }
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  /* ================= ADD ================= */
  const addSlider = async () => {
    if (!sliderImg) {
      toast.error("Please select image");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("thirdImg", sliderImg); // ⚠️ same name as backend

      const res = await fetch(`${API_BASE}/addthirdImg`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("Slider added successfully");
        setShowModal(false);
        setSliderImg(null);
        fetchSliders();
      } else {
        toast.error(data.message || "Upload failed");
      }
    } catch {
      toast.error("Something went wrong");
    }
  };

  /* ================= DELETE ================= */
  const deleteSlider = async (id) => {
    try {
      await fetch(`${API_BASE}/deletethirdimg/${id}`, {
        method: "DELETE",
      });
      toast.success("Deleted");
      fetchSliders();
    } catch {
      toast.error("Delete failed");
    }
  };

  /* ================= SORT ================= */
  const sortByName = () => {
    const sorted = [...sliders].sort((a, b) =>
      sortDir === "asc"
        ? (a.thirdImg || "").localeCompare(b.thirdImg || "")
        : (b.thirdImg || "").localeCompare(a.thirdImg || ""),
    );
    setSliders(sorted);
    setSortDir(sortDir === "asc" ? "desc" : "asc");
  };

  /* ================= UI ================= */
  return (
    <>
      <div className="m-6 space-y-6">
        {/* HEADER */}
        <div className="flex justify-between items-center bg-[#1F2A40] p-5 rounded-xl">
          <h2 className="text-2xl font-bold text-white">Health Slider</h2>

          <button
            onClick={() => setShowModal(true)}
            className="flex items-center gap-2 px-6 py-2 rounded-xl text-white"
            style={{ background: "linear-gradient(135deg,#4cceac,#2bbfa4)" }}
          >
            <AddOutlined />
            Add Health Slider
          </button>
        </div>

        {/* TABLE */}
        <div className="bg-[#1F2A40] rounded-xl overflow-hidden">
          <table className="w-full text-white">
            <thead className="bg-[#3E4396]">
              <tr>
                <th className="px-6 py-4 text-left">#</th>
                <th className="px-6 py-4 text-left">
                  Image
                  <button onClick={sortByName}>
                    {sortDir === "asc" ? <FaCaretUp /> : <FaCaretDown />}
                  </button>
                </th>
                <th className="px-6 py-4 text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {sliders.length > 0 ? (
                sliders.map((el, i) => (
                  <tr key={el._id} className="border-b border-gray-700">
                    <td className="px-6 py-4">{i + 1}</td>

                    <td className="px-6 py-4">
                      <img
                        src={`http://localhost:8500/uploads/${el.thirdImg}`}
                        alt="slider"
                        className="w-40 h-20 object-cover rounded"
                      />
                    </td>

                    <td className="px-6 py-4 text-center">
                      <button
                        onClick={() => deleteSlider(el._id)}
                        className="bg-red-500 hover:bg-red-600 p-3 rounded-xl shadow-lg transition transform hover:scale-110"
                      >
                        <FaTrash className="text-white text-lg" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-6">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= MODAL ================= */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* BACKDROP */}
          <div
            className="absolute inset-0 bg-black/70 backdrop-blur-md"
            onClick={() => setShowModal(false)}
          ></div>

          {/* MODAL */}
          <div className="relative w-[420px] p-6 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl">
            <h2 className="text-white text-xl font-semibold mb-5 text-center">
              Upload Slider Image
            </h2>

            {/* FILE INPUT */}
            <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-400 rounded-xl p-6 cursor-pointer hover:border-green-400 transition">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setSliderImg(e.target.files[0])}
                className="hidden"
              />

              <span className="text-gray-300 text-sm">
                Click or Drag Image Here
              </span>
            </label>

            {/* PREVIEW */}
            {sliderImg && (
              <img
                src={URL.createObjectURL(sliderImg)}
                className="mt-4 w-full h-44 object-cover rounded-xl"
              />
            )}

            {/* BUTTONS */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowModal(false)}
                className="px-5 py-2 bg-gray-500 rounded-lg text-white"
              >
                Cancel
              </button>

              <button
                onClick={addSlider}
                className="px-5 py-2 bg-green-500 rounded-lg text-white hover:scale-105 transition"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HealthComponet;
